// Таблица символов шрифт > размер > ширина в px
/* tslint:disable */
const charsList = {
    '0': 9,
    '1': 5,
    '2': 9,
    '3': 8,
    '4': 9,
    '5': 8,
    '6': 8,
    '7': 8,
    '8': 8,
    '9': 8,
    ' ': 6,
    ' ': 6,
    '!': 2,
    '"': 5,
    '#': 11,
    $: 9,
    '%': 14,
    '&': 11,
    "'": 2,
    '(': 5,
    ')': 5,
    '*': 5,
    ',': 2,
    '-': 5,
    '.': 2,
    '/': 7,
    ':': 2,
    ';': 2,
    '<': 9,
    '=': 9,
    '>': 9,
    '?': 8,
    '@': 17,
    A: 13,
    C: 11,
    D: 11,
    F: 9,
    G: 12,
    H: 11,
    I: 2,
    J: 8,
    K: 11,
    L: 8,
    M: 13,
    N: 11,
    O: 12,
    Q: 12,
    R: 12,
    U: 11,
    V: 13,
    W: 17,
    X: 11,
    Y: 12,
    '[': 4,
    '\\': 7,
    ']': 4,
    '^': 7,
    '`': 3,
    a: 8,
    b: 8,
    c: 8,
    d: 8,
    e: 8,
    f: 6,
    g: 9,
    h: 8,
    i: 2,
    j: 4,
    k: 8,
    l: 2,
    m: 12,
    n: 8,
    o: 8,
    p: 8,
    q: 8,
    r: 5,
    s: 7,
    t: 4,
    u: 8,
    v: 11,
    w: 15,
    x: 9,
    y: 11,
    z: 8,
    '{': 6,
    '|': 2,
    '}': 6,
    '¡': 2,
    '¢': 8,
    '£': 9,
    '¤': 9,
    '¦': 2,
    '§': 8,
    '¨': 6,
    '©': 13,
    ª: 6,
    '«': 9,
    '¬': 9,
    '­': 5,
    '®': 13,
    '¯': 11,
    '°': 5,
    '²': 5,
    '³': 5,
    '´': 3,
    µ: 8,
    '·': 2,
    '¸': 3,
    '¹': 4,
    º: 7,
    '»': 9,
    '¼': 14,
    '½': 14,
    '¾': 15,
    '¿': 9,
    À: 13,
    Á: 13,
    Â: 13,
    Ã: 13,
    Ä: 13,
    Å: 13,
    Æ: 18,
    Ç: 11,
    Ì: 3,
    Í: 3,
    Î: 8,
    Ï: 6,
    Ð: 12,
    Ñ: 11,
    Ò: 12,
    Ó: 12,
    Ô: 12,
    Õ: 12,
    Ö: 12,
    '×': 7,
    Ø: 13,
    Ù: 11,
    Ú: 11,
    Û: 11,
    Ü: 11,
    Ý: 12,
    ß: 9,
    à: 8,
    á: 8,
    â: 8,
    ã: 8,
    ä: 8,
    å: 8,
    æ: 15,
    ç: 8,
    è: 8,
    é: 8,
    ê: 8,
    ë: 8,
    ì: 3,
    í: 3,
    î: 8,
    ï: 6,
    ð: 8,
    ñ: 8,
    ò: 8,
    ó: 8,
    ô: 8,
    õ: 8,
    ö: 8,
    ø: 9,
    ù: 8,
    ú: 8,
    û: 8,
    ü: 8,
    ý: 11,
    þ: 8,
    ÿ: 11,
    Ā: 13,
    ā: 8,
    Ă: 13,
    ă: 8,
    Ą: 13,
    ą: 9,
    Ć: 11,
    ć: 8,
    Ĉ: 11,
    ĉ: 8,
    Ċ: 11,
    ċ: 8,
    Č: 11,
    č: 8,
    Ď: 11,
    ď: 11,
    Đ: 12,
    đ: 9,
    ē: 8,
    ĕ: 8,
    ė: 8,
    ę: 8,
    ě: 8,
    Ĝ: 12,
    ĝ: 9,
    Ğ: 12,
    ğ: 9,
    Ġ: 12,
    ġ: 9,
    Ģ: 12,
    ģ: 9,
    Ĥ: 11,
    ĥ: 9,
    Ħ: 13,
    ħ: 9,
    Ĩ: 6,
    ĩ: 6,
    Ī: 5,
    ī: 5,
    Ĭ: 5,
    ĭ: 5,
    Į: 3,
    į: 3,
    İ: 2,
    ı: 2,
    Ĳ: 11,
    ĳ: 6,
    Ĵ: 11,
    ĵ: 8,
    Ķ: 11,
    ķ: 8,
    ĸ: 8,
    Ĺ: 8,
    ĺ: 3,
    Ļ: 8,
    ļ: 5,
    Ľ: 7,
    ľ: 5,
    Ŀ: 8,
    ŀ: 5,
    Ł: 9,
    ł: 4,
    Ń: 11,
    ń: 8,
    Ņ: 11,
    ņ: 8,
    Ň: 11,
    ň: 8,
    Ŋ: 11,
    ŋ: 8,
    Ō: 12,
    ō: 8,
    Ŏ: 12,
    ŏ: 8,
    Ő: 12,
    ő: 8,
    Œ: 16,
    œ: 17,
    Ŕ: 12,
    ŕ: 5,
    Ŗ: 12,
    ŗ: 5,
    Ř: 12,
    ř: 8,
    ś: 7,
    ŝ: 8,
    ş: 7,
    š: 8,
    ţ: 5,
    ť: 6,
    ŧ: 4,
    Ũ: 11,
    ũ: 8,
    Ū: 11,
    ū: 8,
    Ŭ: 11,
    ŭ: 8,
    Ů: 11,
    ů: 8,
    Ű: 11,
    ű: 8,
    Ų: 11,
    ų: 9,
    Ŵ: 17,
    ŵ: 15,
    Ŷ: 12,
    ŷ: 11,
    Ÿ: 12,
    ź: 8,
    ż: 8,
    ž: 9,
    ſ: 4,
    ƀ: 9,
    Ɓ: 13,
    ƃ: 8,
    ƅ: 9,
    Ɔ: 11,
    Ƈ: 13,
    Ɖ: 12,
    Ɗ: 14,
    ƌ: 8,
    ƍ: 8,
    Ə: 13,
    Ɛ: 9,
    Ƒ: 11,
    Ɠ: 14,
    Ɣ: 11,
    ƕ: 14,
    Ɩ: 2,
    Ɨ: 4,
    Ƙ: 12,
    ƙ: 8,
    ƚ: 4,
    ƛ: 9,
    Ɯ: 14,
    Ɲ: 13,
    ƞ: 8,
    Ɵ: 12,
    Ơ: 14,
    Ƣ: 14,
    Ƥ: 13,
    ƥ: 8,
    Ʀ: 11,
    ƨ: 7,
    Ʃ: 8,
    ƪ: 7,
    ƫ: 5,
    Ƭ: 11,
    ƭ: 6,
    Ư: 14,
    ư: 11,
    Ʊ: 11,
    Ʋ: 11,
    Ƴ: 14,
    ƴ: 13,
    Ƶ: 9,
    ƶ: 7,
    ƹ: 8,
    ƺ: 8,
    ƻ: 9,
    Ƽ: 8,
    ƽ: 7,
    ƾ: 8,
    ƿ: 8,
    ǀ: 2,
    ǁ: 5,
    ǃ: 2,
    Ǆ: 22,
    ǅ: 20,
    ǆ: 17,
    Ǉ: 17,
    ǈ: 13,
    ǉ: 6,
    Ǌ: 20,
    ǋ: 15,
    ǌ: 12,
    Ǎ: 13,
    ǎ: 9,
    Ǐ: 8,
    ǐ: 8,
    Ǒ: 12,
    ǒ: 8,
    Ǔ: 11,
    ǔ: 8,
    Ǖ: 11,
    ǖ: 8,
    Ǘ: 11,
    ǘ: 8,
    Ǚ: 11,
    ǚ: 8,
    Ǜ: 11,
    ǜ: 8,
    ǝ: 8,
    Ǟ: 13,
    ǟ: 8,
    Ǡ: 13,
    ǡ: 8,
    Ǣ: 18,
    ǣ: 15,
    Ǥ: 13,
    ǥ: 9,
    Ǧ: 12,
    ǧ: 9,
    Ǩ: 11,
    ǩ: 8,
    Ǫ: 12,
    ǫ: 8,
    Ǭ: 12,
    ǭ: 8,
    ǯ: 8,
    ǰ: 8,
    Ǳ: 22,
    ǲ: 20,
    ǳ: 17,
    Ǵ: 12,
    ǵ: 9,
    Ƕ: 17,
    Ƿ: 9,
    Ǹ: 11,
    ǹ: 8,
    Ǻ: 13,
    ǻ: 8,
    Ǽ: 18,
    ǽ: 15,
    Ǿ: 13,
    ǿ: 9,
    Ȁ: 13,
    ȁ: 8,
    Ȃ: 13,
    ȃ: 8,
    ȅ: 8,
    ȇ: 8,
    Ȉ: 6,
    ȉ: 6,
    Ȋ: 5,
    ȋ: 5,
    Ȍ: 12,
    ȍ: 8,
    Ȏ: 12,
    ȏ: 8,
    Ȑ: 12,
    ȑ: 6,
    Ȓ: 12,
    ȓ: 5,
    Ȕ: 11,
    ȕ: 8,
    Ȗ: 11,
    ȗ: 8,
    ș: 7,
    ț: 5,
    Ȝ: 8,
    ȝ: 6,
    Ȟ: 11,
    ȟ: 8,
    Ƞ: 11,
    ȡ: 11,
    Ȣ: 9,
    ȣ: 8,
    Ȥ: 11,
    ȥ: 8,
    Ȧ: 13,
    ȧ: 8,
    ȩ: 8,
    Ȫ: 12,
    ȫ: 8,
    Ȭ: 12,
    ȭ: 8,
    Ȯ: 12,
    ȯ: 8,
    Ȱ: 12,
    ȱ: 8,
    Ȳ: 12,
    ȳ: 11,
    ȴ: 7,
    ȵ: 11,
    ȶ: 7,
    ȷ: 4,
    ȸ: 14,
    ȹ: 14,
    Ⱥ: 14,
    Ȼ: 11,
    ȼ: 7,
    Ƚ: 9,
    Ⱦ: 11,
    ȿ: 7,
    ɀ: 8,
    ɂ: 8,
    Ƀ: 11,
    Ʉ: 13,
    Ʌ: 13,
    ɇ: 9,
    Ɉ: 9,
    ɉ: 6,
    Ɋ: 13,
    ɋ: 11,
    Ɍ: 13,
    ɍ: 7,
    Ɏ: 12,
    ɏ: 9,
    ɐ: 9,
    ɑ: 8,
    ɒ: 8,
    ɓ: 8,
    ɔ: 7,
    ɕ: 7,
    ɘ: 8,
    ə: 8,
    ɚ: 12,
    ɛ: 7,
    ɜ: 7,
    ɞ: 7,
    ɟ: 6,
    ɠ: 11,
    ɡ: 9,
    ɢ: 8,
    ɣ: 9,
    ɤ: 11,
    ɥ: 8,
    ɦ: 8,
    ɧ: 8,
    ɨ: 4,
    ɩ: 4,
    ɪ: 6,
    ɫ: 7,
    ɬ: 5,
    ɭ: 4,
    ɮ: 8,
    ɯ: 12,
    ɰ: 12,
    ɱ: 12,
    ɴ: 8,
    ɵ: 8,
    ɶ: 12,
    ɷ: 12,
    ɹ: 5,
    ɺ: 5,
    ɻ: 7,
    ɼ: 5,
    ɽ: 5,
    ɾ: 5,
    ɿ: 5,
    ʀ: 9,
    ʁ: 9,
    ʂ: 7,
    ʃ: 6,
    ʄ: 6,
    ʅ: 6,
    ʆ: 6,
    ʇ: 5,
    ʈ: 5,
    ʊ: 8,
    ʋ: 8,
    ʌ: 9,
    ʍ: 13,
    ʎ: 9,
    ʏ: 9,
    ʐ: 9,
    ʑ: 8,
    ʒ: 8,
    ʓ: 9,
    ʔ: 8,
    ʕ: 8,
    ʖ: 8,
    ʗ: 8,
    ʘ: 12,
    ʙ: 8,
    ʚ: 7,
    ʜ: 8,
    ʝ: 7,
    ʞ: 8,
    ʟ: 5,
    ʡ: 8,
    ʢ: 8,
    ʣ: 16,
    ʤ: 14,
    ʥ: 17,
    ʦ: 12,
    ʧ: 9,
    ʨ: 12,
    ʩ: 13,
    ʫ: 9,
    ʬ: 9,
    ʭ: 8,
    ʮ: 11,
    ʯ: 14,
    ʰ: 5,
    ʱ: 5,
    ʲ: 2,
    ʳ: 3,
    ʴ: 3,
    ʵ: 4,
    ʶ: 5,
    ʷ: 9,
    ʸ: 6,
    ʹ: 2,
    ʺ: 5,
    ʻ: 2,
    ʼ: 2,
    ʽ: 2,
    ʾ: 2,
    ʿ: 2,
    ˀ: 5,
    ˁ: 5,
    '˂': 9,
    '˃': 9,
    '˄': 9,
    '˅': 9,
    ˆ: 8,
    ˇ: 8,
    ˈ: 1,
    ˉ: 5,
    ˊ: 3,
    ˋ: 3,
    ˌ: 1,
    ˍ: 6,
    ˎ: 3,
    ˏ: 3,
    ː: 3,
    ˑ: 3,
    '˒': 2,
    '˓': 2,
    '˔': 3,
    '˕': 3,
    '˖': 3,
    '˗': 6,
    '˘': 5,
    '˙': 2,
    '˚': 3,
    '˛': 3,
    '˜': 6,
    '˝': 6,
    '˞': 6,
    '˟': 6,
    ˠ: 7,
    ˡ: 1,
    ˢ: 4,
    ˣ: 6,
    ˤ: 5,
    '˥': 5,
    '˦': 5,
    '˧': 5,
    '˨': 5,
    '˩': 5,
    '˪': 4,
    '˫': 4,
    ˬ: 8,
    '˭': 6,
    ˮ: 5,
    '˯': 4,
    '˰': 4,
    '˱': 2,
    '˲': 2,
    '˳': 3,
    '˴': 3,
    '˵': 6,
    '˶': 6,
    '˷': 6,
    '˸': 2,
    '˹': 3,
    '˺': 3,
    '˻': 3,
    '˼': 3,
    '˽': 7,
    '˾': 7,
    '˿': 5,
    '̀': 3,
    '́': 4,
    '̂': 8,
    '̃': 7,
    '̄': 5,
    '̆': 5,
    '̇': 2,
    '̈': 6,
    '̉': 4,
    '̊': 3,
    '̋': 6,
    '̌': 8,
    '̍': 1,
    '̎': 3,
    '̏': 6,
    '̐': 5,
    '̑': 5,
    '̒': 2,
    '̓': 2,
    '̔': 2,
    '̕': 2,
    '̖': 3,
    '̗': 3,
    '̘': 3,
    '̙': 3,
    '̚': 7,
    '̛': 3,
    '̜': 2,
    '̝': 3,
    '̞': 3,
    '̟': 3,
    '̠': 5,
    '̡': 4,
    '̢': 4,
    '̣': 2,
    '̤': 6,
    '̥': 3,
    '̦': 2,
    '̧': 3,
    '̨': 3,
    '̩': 1,
    '̪': 7,
    '̫': 7,
    '̬': 8,
    '̭': 8,
    '̮': 5,
    '̯': 5,
    '̰': 5,
    '̱': 5,
    '̳': 5,
    '̴': 5,
    '̵': 5,
    '̷': 8,
    '̸': 6,
    '̹': 2,
    '̺': 7,
    '̻': 3,
    '̼': 7,
    '̽': 4,
    '̾': 2,
    '̀': 3,
    '́': 3,
    '͂': 6,
    '̓': 2,
    '̈́': 8,
    'ͅ': 2,
    '͆': 7,
    '͇': 9,
    '͈': 3,
    '͉': 3,
    '͊': 6,
    '͋': 6,
    '͌': 6,
    '͍': 6,
    '͎': 3,
    '͏': 13,
    '͐': 2,
    '͑': 2,
    '͒': 5,
    '͓': 4,
    '͔': 2,
    '͕': 2,
    '͖': 6,
    '͗': 2,
    '͘': 1,
    '͙': 3,
    '͚': 5,
    '͛': 4,
    '͜': 14,
    '͝': 14,
    '͠': 14,
    '͡': 14,
    '͢': 11,
    'ͣ': 5,
    'ͤ': 5,
    'ͥ': 1,
    'ͦ': 5,
    'ͧ': 5,
    'ͨ': 5,
    'ͩ': 5,
    'ͪ': 5,
    'ͫ': 9,
    'ͬ': 3,
    'ͭ': 3,
    'ͮ': 6,
    'ͯ': 6,
    ʹ: 3,
    '͵': 3,
    ͺ: 2,
    ͻ: 7,
    ͼ: 8,
    ͽ: 7,
    ';': 2,
    '΄': 3,
    '΅': 8,
    Ά: 13,
    '·': 2,
    Έ: 14,
    Ή: 14,
    Ί: 6,
    Ό: 14,
    Ύ: 16,
    Ώ: 14,
    ΐ: 8,
    Α: 13,
    Γ: 8,
    Δ: 13,
    Η: 11,
    Θ: 12,
    Ι: 2,
    Κ: 11,
    Λ: 13,
    Μ: 13,
    Ν: 11,
    Ο: 12,
    Π: 11,
    Σ: 8,
    Υ: 12,
    Φ: 12,
    Χ: 11,
    Ψ: 12,
    Ω: 11,
    Ϊ: 6,
    Ϋ: 12,
    ά: 8,
    έ: 7,
    ή: 8,
    ί: 3,
    ΰ: 8,
    α: 8,
    β: 8,
    δ: 8,
    ε: 7,
    ζ: 7,
    η: 8,
    θ: 8,
    ι: 2,
    κ: 9,
    λ: 9,
    μ: 8,
    ν: 11,
    ξ: 7,
    ο: 8,
    π: 12,
    ρ: 8,
    ς: 7,
    τ: 6,
    υ: 8,
    χ: 9,
    ω: 12,
    ϊ: 6,
    ϋ: 8,
    ό: 8,
    ύ: 8,
    ώ: 12,
    ϐ: 8,
    ϒ: 14,
    ϓ: 18,
    ϔ: 14,
    ϕ: 8,
    ϖ: 12,
    ϗ: 11,
    Ϙ: 12,
    ϙ: 8,
    Ϛ: 11,
    ϛ: 8,
    Ϝ: 9,
    ϝ: 5,
    Ϟ: 11,
    ϟ: 8,
    Ϡ: 13,
    ϡ: 9,
    Ϣ: 14,
    ϣ: 12,
    ϥ: 8,
    ϧ: 8,
    Ϫ: 11,
    ϫ: 11,
    Ϭ: 11,
    ϭ: 8,
    Ϯ: 8,
    ϯ: 7,
    ϰ: 11,
    ϱ: 8,
    ϲ: 8,
    ϳ: 4,
    ϴ: 12,
    ϵ: 7,
    '϶': 7,
    ϸ: 8,
    Ϲ: 11,
    Ϻ: 13,
    ϼ: 9,
    Ͻ: 11,
    Ͼ: 11,
    Ͽ: 11,
    Ђ: 15,
    Ѓ: 8,
    Є: 13,
    І: 2,
    Ї: 6,
    Ј: 8,
    Љ: 18,
    Њ: 16,
    Ћ: 14,
    Ќ: 9,
    Ѝ: 11,
    Ў: 13,
    А: 13,
    Г: 8,
    Д: 12,
    Ж: 16,
    З: 9,
    И: 11,
    Й: 11,
    К: 9,
    Л: 11,
    М: 13,
    Н: 11,
    О: 12,
    П: 11,
    С: 11,
    У: 13,
    Ф: 12,
    Х: 11,
    Ц: 12,
    Ш: 14,
    Щ: 15,
    Ъ: 13,
    Ы: 13,
    Ь: 9,
    Э: 13,
    Ю: 16,
    Я: 12,
    а: 8,
    б: 8,
    в: 8,
    г: 6,
    д: 11,
    е: 8,
    ж: 12,
    з: 7,
    и: 8,
    й: 8,
    к: 7,
    н: 8,
    о: 8,
    п: 8,
    р: 8,
    с: 8,
    т: 8,
    у: 11,
    ф: 12,
    х: 9,
    ц: 9,
    ч: 7,
    ш: 12,
    щ: 13,
    ъ: 9,
    ы: 11,
    ь: 8,
    э: 8,
    ю: 12,
    я: 9,
    ѐ: 8,
    ё: 8,
    ђ: 9,
    ѓ: 6,
    є: 8,
    ѕ: 7,
    і: 2,
    ї: 6,
    ј: 4,
    љ: 15,
    њ: 13,
    ћ: 9,
    ќ: 7,
    ѝ: 8,
    ў: 11,
    џ: 8,
    Ѡ: 22,
    ѡ: 11,
    Ѣ: 13,
    Ѥ: 15,
    ѥ: 11,
    Ѧ: 12,
    ѧ: 9,
    Ѩ: 14,
    ѩ: 12,
    Ѫ: 14,
    Ѭ: 18,
    ѭ: 14,
    Ѯ: 9,
    ѯ: 8,
    Ѱ: 12,
    ѱ: 11,
    Ѳ: 12,
    ѳ: 8,
    Ѵ: 15,
    ѵ: 11,
    Ѷ: 15,
    ѷ: 11,
    Ѹ: 20,
    ѹ: 17,
    Ѻ: 13,
    Ѽ: 19,
    ѽ: 13,
    Ѿ: 22,
    ѿ: 11,
    Ҁ: 11,
    ҁ: 7,
    '҂': 9,
    '҃': 6,
    '҄': 6,
    '҅': 2,
    '҆': 2,
    '҇': 9,
    '҈': 18,
    '҉': 16,
    Ҋ: 12,
    Ҍ: 11,
    ҍ: 8,
    Ҏ: 11,
    ҏ: 9,
    Ґ: 7,
    ґ: 5,
    ғ: 7,
    ҕ: 8,
    Җ: 16,
    җ: 12,
    Ҙ: 9,
    ҙ: 6,
    Қ: 9,
    қ: 7,
    Ҝ: 9,
    ҝ: 7,
    ҟ: 9,
    Ҡ: 13,
    Ң: 12,
    ң: 9,
    Ҥ: 15,
    ҥ: 11,
    Ҧ: 18,
    ҧ: 14,
    Ҩ: 13,
    ҩ: 9,
    Ҫ: 11,
    ҫ: 7,
    ҭ: 8,
    Ҳ: 11,
    ҳ: 9,
    Ҵ: 16,
    ҵ: 12,
    Ҷ: 11,
    ҷ: 8,
    ҹ: 7,
    Һ: 11,
    һ: 8,
    Ҽ: 15,
    ҽ: 11,
    Ҿ: 15,
    ҿ: 11,
    Ӏ: 2,
    Ӂ: 16,
    ӂ: 12,
    ӄ: 8,
    Ӆ: 12,
    ӆ: 12,
    Ӈ: 11,
    ӈ: 8,
    Ӊ: 12,
    ӌ: 7,
    Ӎ: 15,
    ӎ: 12,
    ӏ: 2,
    Ӑ: 13,
    ӑ: 8,
    Ӓ: 13,
    ӓ: 8,
    Ӕ: 18,
    ӕ: 15,
    ӗ: 8,
    Ә: 13,
    ә: 8,
    Ӛ: 13,
    ӛ: 8,
    Ӝ: 16,
    ӝ: 12,
    Ӟ: 9,
    ӟ: 7,
    Ӡ: 9,
    ӡ: 8,
    Ӣ: 11,
    ӣ: 8,
    Ӥ: 11,
    ӥ: 8,
    Ӧ: 12,
    ӧ: 8,
    Ө: 12,
    ө: 8,
    Ӫ: 12,
    ӫ: 8,
    Ӭ: 13,
    ӭ: 8,
    Ӯ: 13,
    ӯ: 11,
    Ӱ: 13,
    ӱ: 11,
    Ӳ: 13,
    ӳ: 11,
    ӵ: 7,
    Ӷ: 9,
    ӷ: 6,
    Ӹ: 13,
    ӹ: 11,
    Ӻ: 11,
    ӻ: 8,
    Ӽ: 12,
    ӽ: 9,
    Ӿ: 12,
    ӿ: 9,
    ԁ: 8,
    Ԃ: 15,
    ԃ: 14,
    Ԅ: 15,
    ԅ: 13,
    ԇ: 7,
    Ԉ: 16,
    ԉ: 15,
    Ԋ: 17,
    ԋ: 14,
    Ԍ: 12,
    ԍ: 8,
    Ԏ: 12,
    ԏ: 11,
    Ԑ: 9,
    ԑ: 7,
    Ԓ: 12,
    Ԛ: 12,
    ԛ: 8,
    Ԝ: 17,
    ԝ: 15,
    '֑': 3,
    '֒': 5,
    '֓': 2,
    '֔': 1,
    '֕': 3,
    '֖': 4,
    '֗': 3,
    '֘': 5,
    '֙': 3,
    '֚': 3,
    '֛': 4,
    '֜': 3,
    '֝': 3,
    '֞': 6,
    '֟': 11,
    '֠': 5,
    '֡': 3,
    '֢': 3,
    '֣': 3,
    '֤': 3,
    '֥': 4,
    '֦': 7,
    '֧': 2,
    '֨': 3,
    '֩': 5,
    '֪': 3,
    '֫': 3,
    '֬': 3,
    '֭': 4,
    '֮': 5,
    '֯': 3,
    'ְ': 1,
    'ֱ': 5,
    'ֲ': 5,
    'ֳ': 5,
    'ִ': 1,
    'ֵ': 3,
    'ֶ': 3,
    'ַ': 4,
    'ָ': 3,
    'ֹ': 1,
    'ֺ': 1,
    'ֻ': 5,
    'ּ': 1,
    'ֽ': 1,
    '־': 5,
    'ֿ': 4,
    '׀': 2,
    'ׁ': 1,
    'ׂ': 1,
    '׃': 2,
    'ׄ': 1,
    'ׅ': 1,
    '׆': 4,
    'ׇ': 3,
    א: 9,
    ב: 8,
    ג: 7,
    ד: 7,
    ה: 9,
    ו: 2,
    ז: 5,
    ח: 9,
    ט: 9,
    י: 2,
    ך: 8,
    כ: 6,
    ל: 6,
    ם: 9,
    ן: 2,
    נ: 4,
    ס: 8,
    ע: 8,
    ף: 8,
    פ: 8,
    ץ: 8,
    צ: 9,
    ק: 8,
    ר: 8,
    ש: 11,
    װ: 7,
    ױ: 7,
    ײ: 7,
    '׳': 3,
    '״': 7,
    '؀': 11,
    '؁': 23,
    '؂': 13,
    '؃': 16,
    '؋': 6,
    '،': 3,
    '؍': 4,
    '؎': 14,
    '؏': 9,
    'ؐ': 7,
    'ؑ': 5,
    'ؒ': 7,
    'ؓ': 9,
    'ؔ': 8,
    'ؕ': 4,
    '؛': 3,
    '؞': 5,
    '؟': 6,
    ء: 5,
    آ: 4,
    أ: 3,
    ؤ: 8,
    إ: 3,
    ا: 2,
    ب: 12,
    ة: 4,
    ت: 12,
    ث: 12,
    ج: 9,
    ح: 9,
    خ: 9,
    د: 6,
    ذ: 6,
    ر: 8,
    ز: 8,
    س: 14,
    ش: 14,
    ص: 19,
    ض: 19,
    ط: 11,
    ظ: 11,
    ـ: 5,
    ف: 14,
    ق: 9,
    ك: 11,
    ل: 8,
    م: 6,
    ن: 8,
    ه: 5,
    و: 8,
    'ً': 3,
    'ٌ': 6,
    'ٍ': 3,
    'َ': 3,
    'ُ': 4,
    'ِ': 3,
    'ّ': 7,
    'ْ': 3,
    'ٓ': 4,
    'ٔ': 3,
    'ٕ': 3,
    'ٖ': 2,
    'ٗ': 4,
    '٘': 5,
    'ٙ': 3,
    'ٚ': 3,
    'ٛ': 3,
    'ٜ': 2,
    'ٝ': 4,
    'ٞ': 4,
    '٠': 3,
    '١': 4,
    '٢': 6,
    '٣': 8,
    '٤': 4,
    '٥': 7,
    '٦': 8,
    '٧': 7,
    '٨': 7,
    '٩': 6,
    '٪': 7,
    '٫': 3,
    '٬': 3,
    '٭': 7,
    ٮ: 12,
    ٯ: 9,
    'ٰ': 2,
    ٱ: 4,
    ٲ: 4,
    ٳ: 4,
    ٴ: 3,
    ٵ: 5,
    ٶ: 9,
    ٷ: 9,
    ٸ: 11,
    ٹ: 12,
    ٺ: 12,
    ٻ: 12,
    ټ: 12,
    ٽ: 12,
    پ: 12,
    ٿ: 12,
    ڀ: 12,
    ځ: 9,
    ڂ: 9,
    ڃ: 9,
    ڄ: 9,
    څ: 9,
    چ: 9,
    ڇ: 9,
    ڈ: 6,
    ډ: 6,
    ڊ: 6,
    ڋ: 6,
    ڌ: 6,
    ڍ: 6,
    ڎ: 6,
    ڏ: 6,
    ڐ: 6,
    ڑ: 8,
    ڒ: 8,
    ړ: 8,
    ڔ: 8,
    ڕ: 8,
    ږ: 8,
    ڗ: 8,
    ژ: 8,
    ڙ: 8,
    ښ: 14,
    ڛ: 14,
    ڜ: 14,
    ڝ: 19,
    ڞ: 19,
    ڟ: 11,
    ڡ: 14,
    ڢ: 14,
    ڣ: 14,
    ڤ: 14,
    ڥ: 14,
    ڦ: 14,
    ڧ: 9,
    ڨ: 9,
    ک: 15,
    ڪ: 20,
    ګ: 15,
    ڬ: 11,
    ڭ: 11,
    ڮ: 11,
    گ: 15,
    ڰ: 15,
    ڱ: 15,
    ڲ: 15,
    ڳ: 15,
    ڴ: 15,
    ڵ: 8,
    ڶ: 8,
    ڷ: 8,
    ڸ: 8,
    ڹ: 8,
    ں: 8,
    ڻ: 8,
    ڼ: 8,
    ڽ: 8,
    ھ: 8,
    ڿ: 9,
    ۀ: 5,
    ہ: 7,
    ۂ: 7,
    ۃ: 7,
    ۄ: 8,
    ۅ: 8,
    ۆ: 8,
    ۇ: 8,
    ۈ: 8,
    ۉ: 8,
    ۊ: 8,
    ۋ: 8,
    ۍ: 11,
    ۏ: 8,
    ے: 15,
    ۓ: 15,
    '۔': 3,
    ە: 5,
    'ۖ': 9,
    'ۗ': 8,
    'ۘ': 4,
    'ۙ': 5,
    'ۚ': 5,
    'ۛ': 2,
    'ۜ': 6,
    '۝': 20,
    '۞': 20,
    '۟': 1,
    '۠': 1,
    'ۡ': 5,
    'ۢ': 3,
    'ۣ': 6,
    'ۤ': 2,
    ۥ: 3,
    ۦ: 8,
    'ۧ': 8,
    'ۨ': 4,
    '۩': 13,
    '۪': 3,
    '۫': 3,
    '۬': 1,
    'ۭ': 3,
    ۮ: 6,
    ۯ: 8,
    '۰': 3,
    '۱': 4,
    '۲': 6,
    '۳': 8,
    '۴': 6,
    '۵': 6,
    '۶': 6,
    '۷': 7,
    '۸': 7,
    '۹': 6,
    ۺ: 14,
    ۻ: 19,
    '۽': 5,
    '۾': 6,
    ۿ: 8,
    ݐ: 12,
    ݑ: 12,
    ݒ: 12,
    ݓ: 12,
    ݔ: 12,
    ݕ: 12,
    ݖ: 12,
    ݗ: 9,
    ݘ: 9,
    ݙ: 6,
    ݚ: 6,
    ݛ: 8,
    ݜ: 14,
    ݠ: 14,
    ݡ: 14,
    ݢ: 15,
    ݣ: 15,
    ݤ: 15,
    ݥ: 6,
    ݦ: 6,
    ݧ: 8,
    ݨ: 8,
    ݩ: 8,
    ݪ: 8,
    ݫ: 8,
    ݬ: 8,
    ݭ: 14,
    ᴀ: 9,
    ᴁ: 12,
    ᴂ: 15,
    ᴄ: 8,
    ᴅ: 8,
    ᴆ: 9,
    ᴇ: 7,
    ᴈ: 7,
    ᴉ: 2,
    ᴊ: 7,
    ᴋ: 9,
    ᴌ: 6,
    ᴎ: 8,
    ᴏ: 8,
    ᴐ: 7,
    ᴑ: 9,
    ᴒ: 9,
    ᴓ: 11,
    ᴔ: 16,
    ᴕ: 6,
    ᴖ: 8,
    ᴗ: 8,
    ᴘ: 7,
    ᴙ: 9,
    ᴚ: 9,
    ᴛ: 8,
    ᴜ: 8,
    ᴝ: 9,
    ᴞ: 11,
    ᴟ: 9,
    ᴠ: 11,
    ᴡ: 15,
    ᴢ: 8,
    ᴣ: 7,
    ᴤ: 6,
    ᴥ: 11,
    ᴦ: 6,
    ᴧ: 9,
    ᴨ: 8,
    ᴩ: 7,
    ᴪ: 12,
    ᴬ: 8,
    ᴭ: 11,
    ᴮ: 5,
    ᴯ: 7,
    ᴰ: 6,
    ᴱ: 5,
    ᴲ: 5,
    ᴳ: 7,
    ᴴ: 6,
    ᴵ: 1,
    ᴶ: 6,
    ᴷ: 7,
    ᴸ: 4,
    ᴹ: 7,
    ᴺ: 6,
    ᴻ: 6,
    ᴼ: 7,
    ᴽ: 5,
    ᴾ: 6,
    ᴿ: 7,
    ᵀ: 7,
    ᵁ: 6,
    ᵂ: 11,
    ᵃ: 5,
    ᵄ: 6,
    ᵅ: 5,
    ᵇ: 5,
    ᵈ: 5,
    ᵉ: 5,
    ᵊ: 5,
    ᵋ: 5,
    ᵌ: 5,
    ᵍ: 6,
    ᵎ: 1,
    ᵏ: 5,
    ᵐ: 9,
    ᵑ: 5,
    ᵒ: 5,
    ᵓ: 5,
    ᵔ: 5,
    ᵕ: 5,
    ᵖ: 5,
    ᵗ: 3,
    ᵘ: 5,
    ᵙ: 5,
    ᵚ: 9,
    ᵛ: 6,
    ᵜ: 7,
    ᵝ: 5,
    ᵞ: 6,
    ᵟ: 5,
    ᵠ: 7,
    ᵡ: 6,
    ᵢ: 1,
    ᵣ: 3,
    ᵤ: 5,
    ᵥ: 6,
    ᵦ: 5,
    ᵧ: 6,
    ᵨ: 5,
    ᵩ: 7,
    ᵪ: 6,
    ᵫ: 15,
    ᵮ: 8,
    ᵯ: 14,
    ᵰ: 12,
    ᵲ: 8,
    ᵳ: 8,
    ᵵ: 7,
    ᵶ: 8,
    ᵷ: 9,
    ᵸ: 5,
    ᵹ: 8,
    ᵺ: 14,
    ᵻ: 4,
    ᵼ: 4,
    ᶀ: 8,
    ᶁ: 9,
    ᶂ: 6,
    ᶃ: 13,
    ᶄ: 8,
    ᶅ: 4,
    ᶆ: 13,
    ᶇ: 9,
    ᶈ: 8,
    ᶉ: 6,
    ᶊ: 7,
    ᶋ: 8,
    ᶌ: 9,
    ᶍ: 9,
    ᶎ: 7,
    ᶏ: 11,
    ᶐ: 11,
    ᶓ: 9,
    ᶔ: 6,
    ᶕ: 12,
    ᶖ: 5,
    ᶗ: 7,
    ᶘ: 6,
    ᶙ: 11,
    ᶚ: 8,
    ᶛ: 5,
    ᶜ: 5,
    ᶝ: 5,
    ᶞ: 5,
    ᶟ: 5,
    ᶠ: 4,
    ᶡ: 4,
    ᶢ: 6,
    ᶣ: 5,
    ᶤ: 3,
    ᶥ: 1,
    ᶦ: 1,
    ᶧ: 3,
    ᶨ: 5,
    ᶩ: 2,
    ᶪ: 2,
    ᶫ: 4,
    ᶬ: 9,
    ᶭ: 9,
    ᶮ: 6,
    ᶯ: 6,
    ᶰ: 5,
    ᶱ: 5,
    ᶲ: 5,
    ᶳ: 4,
    ᶴ: 3,
    ᶵ: 3,
    ᶶ: 7,
    ᶷ: 5,
    ᶸ: 5,
    ᶹ: 5,
    ᶺ: 6,
    ᶻ: 6,
    ᶼ: 7,
    ᶽ: 6,
    ᶾ: 6,
    ᶿ: 5,
    '᷀': 7,
    '᷁': 7,
    '᷂': 3,
    '᷃': 6,
    '᷄': 6,
    '᷅': 6,
    '᷆': 6,
    '᷇': 6,
    '᷈': 8,
    '᷉': 8,
    '᷊': 3,
    '᷾': 2,
    '᷿': 6,
    Ḁ: 13,
    ḁ: 8,
    ḃ: 8,
    ḅ: 8,
    ḇ: 8,
    Ḉ: 11,
    ḉ: 8,
    Ḋ: 11,
    ḋ: 8,
    Ḍ: 11,
    ḍ: 8,
    Ḏ: 11,
    ḏ: 8,
    Ḑ: 11,
    ḑ: 8,
    Ḓ: 11,
    ḓ: 8,
    ḕ: 8,
    ḗ: 8,
    ḙ: 8,
    ḛ: 8,
    ḝ: 8,
    Ḟ: 9,
    ḟ: 6,
    Ḡ: 12,
    ḡ: 9,
    Ḣ: 11,
    ḣ: 8,
    Ḥ: 11,
    ḥ: 8,
    Ḧ: 11,
    ḧ: 8,
    Ḩ: 11,
    ḩ: 8,
    Ḫ: 11,
    ḫ: 8,
    Ḭ: 5,
    ḭ: 5,
    Ḯ: 5,
    ḯ: 6,
    Ḱ: 11,
    ḱ: 8,
    Ḳ: 11,
    ḳ: 8,
    Ḵ: 11,
    ḵ: 8,
    Ḷ: 8,
    ḷ: 2,
    Ḹ: 8,
    ḹ: 5,
    Ḻ: 8,
    ḻ: 5,
    Ḽ: 8,
    ḽ: 8,
    Ḿ: 13,
    ḿ: 12,
    Ṁ: 13,
    ṁ: 12,
    Ṃ: 13,
    ṃ: 12,
    Ṅ: 11,
    ṅ: 8,
    Ṇ: 11,
    ṇ: 8,
    Ṉ: 11,
    ṉ: 8,
    Ṋ: 11,
    ṋ: 8,
    Ṍ: 12,
    ṍ: 8,
    Ṏ: 12,
    ṏ: 8,
    Ṑ: 12,
    ṑ: 8,
    Ṓ: 12,
    ṓ: 8,
    ṕ: 8,
    ṗ: 8,
    Ṙ: 12,
    ṙ: 5,
    Ṛ: 12,
    ṛ: 5,
    Ṝ: 12,
    ṝ: 5,
    Ṟ: 12,
    ṟ: 5,
    ṡ: 7,
    ṣ: 7,
    ṥ: 7,
    ṧ: 8,
    ṩ: 7,
    ṫ: 4,
    ṭ: 4,
    ṯ: 5,
    ṱ: 8,
    Ṳ: 11,
    ṳ: 8,
    Ṵ: 11,
    ṵ: 8,
    Ṷ: 11,
    ṷ: 8,
    Ṹ: 11,
    ṹ: 8,
    Ṻ: 11,
    ṻ: 8,
    Ṽ: 13,
    ṽ: 11,
    Ṿ: 13,
    ṿ: 11,
    Ẁ: 17,
    ẁ: 15,
    Ẃ: 17,
    ẃ: 15,
    Ẅ: 17,
    ẅ: 15,
    Ẇ: 17,
    ẇ: 15,
    Ẉ: 17,
    ẉ: 15,
    Ẋ: 11,
    ẋ: 9,
    Ẍ: 11,
    ẍ: 9,
    Ẏ: 12,
    ẏ: 11,
    ẑ: 8,
    ẓ: 8,
    ẕ: 8,
    ẖ: 8,
    ẗ: 6,
    ẘ: 15,
    ẙ: 11,
    ẚ: 8,
    ẛ: 4,
    ẞ: 11,
    Ạ: 13,
    ạ: 8,
    Ả: 13,
    ả: 8,
    Ấ: 13,
    ấ: 8,
    Ầ: 13,
    ầ: 8,
    Ẩ: 13,
    ẩ: 8,
    Ẫ: 13,
    ẫ: 8,
    Ậ: 13,
    ậ: 8,
    Ắ: 13,
    ắ: 8,
    Ằ: 13,
    ằ: 8,
    Ẳ: 13,
    ẳ: 8,
    Ẵ: 13,
    ẵ: 8,
    Ặ: 13,
    ặ: 8,
    ẹ: 8,
    ẻ: 8,
    ẽ: 8,
    ế: 8,
    ề: 8,
    ể: 8,
    ễ: 8,
    ệ: 8,
    Ỉ: 4,
    ỉ: 4,
    Ị: 2,
    ị: 2,
    Ọ: 12,
    ọ: 8,
    Ỏ: 12,
    ỏ: 8,
    Ố: 12,
    ố: 8,
    Ồ: 12,
    ồ: 8,
    Ổ: 12,
    ổ: 8,
    Ỗ: 12,
    ỗ: 8,
    Ộ: 12,
    ộ: 8,
    Ớ: 14,
    Ờ: 14,
    Ở: 14,
    Ỡ: 14,
    Ợ: 14,
    Ụ: 11,
    ụ: 8,
    Ủ: 11,
    ủ: 8,
    Ứ: 14,
    ứ: 11,
    Ừ: 14,
    ừ: 11,
    Ử: 14,
    ử: 11,
    Ữ: 14,
    ữ: 11,
    Ự: 14,
    ự: 11,
    Ỳ: 12,
    ỳ: 11,
    Ỵ: 12,
    ỵ: 11,
    Ỷ: 12,
    ỷ: 11,
    Ỹ: 12,
    ỹ: 11,
    ἀ: 8,
    ἁ: 8,
    ἂ: 8,
    ἃ: 8,
    ἄ: 8,
    ἅ: 8,
    ἆ: 8,
    ἇ: 8,
    Ἀ: 13,
    Ἁ: 13,
    Ἂ: 15,
    Ἃ: 15,
    Ἄ: 15,
    Ἅ: 15,
    Ἆ: 16,
    Ἇ: 16,
    ἐ: 7,
    ἑ: 7,
    ἒ: 7,
    ἓ: 7,
    ἔ: 7,
    ἕ: 7,
    Ἐ: 13,
    Ἑ: 13,
    Ἒ: 17,
    Ἓ: 17,
    Ἔ: 17,
    Ἕ: 17,
    ἠ: 8,
    ἡ: 8,
    ἢ: 8,
    ἣ: 8,
    ἤ: 8,
    ἥ: 8,
    ἦ: 8,
    ἧ: 8,
    Ἠ: 14,
    Ἡ: 14,
    Ἢ: 18,
    Ἣ: 18,
    Ἤ: 18,
    Ἥ: 18,
    Ἦ: 18,
    Ἧ: 18,
    ἰ: 2,
    ἱ: 2,
    ἲ: 6,
    ἳ: 6,
    ἴ: 6,
    ἵ: 6,
    ἶ: 7,
    ἷ: 7,
    Ἰ: 5,
    Ἱ: 5,
    Ἲ: 9,
    Ἳ: 9,
    Ἴ: 9,
    Ἵ: 9,
    Ἶ: 9,
    Ἷ: 9,
    ὀ: 8,
    ὁ: 8,
    ὂ: 8,
    ὃ: 8,
    ὄ: 8,
    ὅ: 8,
    Ὀ: 14,
    Ὁ: 14,
    Ὂ: 18,
    Ὃ: 18,
    Ὄ: 17,
    Ὅ: 17,
    ὐ: 8,
    ὑ: 8,
    ὒ: 8,
    ὓ: 8,
    ὔ: 8,
    ὕ: 8,
    ὖ: 8,
    ὗ: 8,
    Ὑ: 15,
    Ὓ: 18,
    Ὕ: 19,
    Ὗ: 18,
    ὠ: 12,
    ὡ: 12,
    ὢ: 12,
    ὣ: 12,
    ὤ: 12,
    ὥ: 12,
    ὦ: 12,
    ὧ: 12,
    Ὠ: 13,
    Ὡ: 13,
    Ὢ: 16,
    Ὣ: 16,
    Ὤ: 16,
    Ὥ: 16,
    Ὦ: 17,
    Ὧ: 17,
    ὰ: 8,
    ά: 8,
    ὲ: 7,
    έ: 7,
    ὴ: 8,
    ή: 8,
    ὶ: 3,
    ί: 3,
    ὸ: 8,
    ό: 8,
    ὺ: 8,
    ύ: 8,
    ὼ: 12,
    ώ: 12,
    ᾀ: 8,
    ᾁ: 8,
    ᾂ: 8,
    ᾃ: 8,
    ᾄ: 8,
    ᾅ: 8,
    ᾆ: 8,
    ᾇ: 8,
    ᾈ: 13,
    ᾉ: 13,
    ᾊ: 15,
    ᾋ: 15,
    ᾌ: 15,
    ᾍ: 15,
    ᾎ: 16,
    ᾏ: 16,
    ᾐ: 8,
    ᾑ: 8,
    ᾒ: 8,
    ᾓ: 8,
    ᾔ: 8,
    ᾕ: 8,
    ᾖ: 8,
    ᾗ: 8,
    ᾘ: 14,
    ᾙ: 14,
    ᾚ: 18,
    ᾛ: 18,
    ᾜ: 18,
    ᾝ: 18,
    ᾞ: 18,
    ᾟ: 18,
    ᾠ: 12,
    ᾡ: 12,
    ᾢ: 12,
    ᾣ: 12,
    ᾤ: 12,
    ᾥ: 12,
    ᾦ: 12,
    ᾧ: 12,
    ᾨ: 13,
    ᾩ: 13,
    ᾪ: 16,
    ᾫ: 16,
    ᾬ: 16,
    ᾭ: 16,
    ᾮ: 17,
    ᾯ: 17,
    ᾰ: 8,
    ᾱ: 8,
    ᾲ: 8,
    ᾳ: 8,
    ᾴ: 8,
    ᾶ: 8,
    ᾷ: 8,
    Ᾰ: 13,
    Ᾱ: 13,
    Ὰ: 13,
    Ά: 13,
    ᾼ: 13,
    '᾽': 2,
    ι: 2,
    '᾿': 2,
    '῀': 7,
    '῁': 7,
    ῂ: 8,
    ῃ: 8,
    ῄ: 8,
    ῆ: 8,
    ῇ: 8,
    Ὲ: 14,
    Έ: 14,
    Ὴ: 15,
    Ή: 15,
    ῌ: 11,
    '῍': 6,
    '῎': 6,
    '῏': 7,
    ῐ: 5,
    ῑ: 5,
    ῒ: 6,
    ΐ: 6,
    ῖ: 6,
    ῗ: 6,
    Ῐ: 5,
    Ῑ: 5,
    Ὶ: 6,
    Ί: 6,
    '῝': 6,
    '῞': 6,
    '῟': 7,
    ῠ: 8,
    ῡ: 8,
    ῢ: 8,
    ΰ: 8,
    ῤ: 8,
    ῥ: 8,
    ῦ: 8,
    ῧ: 8,
    Ῠ: 12,
    Ῡ: 12,
    Ὺ: 16,
    Ύ: 16,
    Ῥ: 13,
    '῭': 8,
    '΅': 8,
    '`': 3,
    ῲ: 12,
    ῳ: 12,
    ῴ: 12,
    ῶ: 12,
    ῷ: 12,
    Ὸ: 15,
    Ό: 14,
    Ὼ: 14,
    Ώ: 13,
    ῼ: 11,
    '´': 3,
    '῾': 2,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    ' ': 0,
    '​': 0,
    '‌': 1,
    '‍': 3,
    '‎': 4,
    '‏': 4,
    '—': 18,
    '―': 16,
    '‖': 5,
    '‘': 2,
    '’': 2,
    '‚': 2,
    '‛': 2,
    '“': 5,
    '”': 5,
    '„': 5,
    '‟': 5,
    '•': 4,
    '…': 14,
    '‪': 4,
    '‫': 4,
    '‬': 5,
    '‭': 5,
    '‮': 5,
    ' ': 0,
    '‰': 17,
    '′': 4,
    '″': 7,
    '‹': 5,
    '›': 5,
    '‼': 6,
    '‾': 6,
    '⁄': 13,
    '⁞': 2,
    '⁪': 5,
    '⁫': 5,
    '⁬': 5,
    '⁭': 5,
    '⁮': 5,
    '⁯': 5,
    ⁿ: 6,
    ₐ: 5,
    ₑ: 5,
    ₒ: 5,
    ₓ: 6,
    ₔ: 5,
    '₡': 11,
    '₢': 11,
    '₣': 8,
    '₤': 9,
    '₥': 12,
    '₦': 13,
    '₧': 19,
    '₨': 19,
    '₩': 17,
    '₪': 14,
    '₫': 7,
    '₭': 13,
    '₯': 18,
    '₰': 9,
    '₱': 12,
    '₲': 12,
    '₳': 14,
    '₵': 11,
    '⃰': 5,
    '℅': 15,
    ℓ: 8,
    '№': 16,
    '℗': 13,
    '™': 13,
    Ω: 12,
    '℮': 9,
    '⅍': 17,
    ⅎ: 7,
    '⅓': 14,
    '⅔': 15,
    '⅛': 14,
    '⅜': 14,
    '⅝': 14,
    '⅞': 13,
    ↄ: 7,
    '←': 18,
    '↑': 7,
    '→': 18,
    '↓': 7,
    '↔': 18,
    '↕': 7,
    '↨': 7,
    '∂': 9,
    '∆': 13,
    '∏': 13,
    '∑': 11,
    '−': 9,
    '∕': 13,
    '∙': 2,
    '√': 9,
    '∟': 12,
    '∫': 4,
    '≠': 8,
    '≡': 9,
    '≤': 9,
    '≥': 8,
    '⌂': 9,
    '⌐': 9,
    '⌠': 5,
    '⌡': 5,
    '─': 14,
    '│': 2,
    '┌': 8,
    '┐': 9,
    '└': 8,
    '┘': 9,
    '├': 8,
    '┤': 9,
    '┬': 14,
    '┴': 14,
    '┼': 14,
    '═': 14,
    '║': 6,
    '╒': 8,
    '╕': 9,
    '╘': 8,
    '╛': 9,
    '╞': 8,
    '╡': 9,
    '╤': 14,
    '╥': 14,
    '╦': 14,
    '╧': 14,
    '╨': 14,
    '╩': 14,
    '╪': 14,
    '╫': 14,
    '╬': 14,
    '▀': 14,
    '▄': 14,
    '█': 14,
    '▌': 8,
    '▐': 7,
    '░': 13,
    '▒': 14,
    '▓': 15,
    '■': 9,
    '□': 9,
    '▪': 5,
    '▫': 5,
    '▬': 18,
    '▲': 14,
    '►': 14,
    '▼': 14,
    '◄': 14,
    '◊': 9,
    '○': 9,
    '◌': 9,
    '●': 9,
    '◘': 9,
    '◙': 11,
    '◦': 6,
    '☺': 12,
    '☻': 13,
    '☼': 17,
    '♂': 13,
    '♣': 12,
    '♥': 11,
    '♦': 9,
    '♪': 9,
    '♫': 12,
    '♯': 9,
    Ⱡ: 9,
    ⱡ: 4,
    Ɫ: 11,
    Ᵽ: 11,
    Ɽ: 12,
    ⱥ: 9,
    ⱦ: 11,
    Ⱨ: 12,
    ⱨ: 9,
    Ⱪ: 11,
    ⱪ: 8,
    Ⱬ: 11,
    ⱬ: 9,
    Ɑ: 11,
    ⱱ: 11,
    Ⱳ: 19,
    ⱳ: 16,
    ⱴ: 9,
    Ⱶ: 8,
    ⱶ: 6,
    ⱷ: 12,
    '⸗': 4,
    ꜗ: 3,
    ꜘ: 4,
    ꜙ: 5,
    ꜚ: 5,
    ꜛ: 7,
    ꜜ: 7,
    ꜝ: 2,
    ꜞ: 2,
    ꜟ: 2,
    '꜠': 6,
    '꜡': 6,
    ꞈ: 7,
    '꞉': 2,
    '꞊': 6,
    Ꞌ: 2,
    ꞌ: 2,
    ﬁ: 8,
    ﬂ: 8,
    יִ: 2,
    'ﬞ': 5,
    ײַ: 7,
    ﬠ: 8,
    ﬡ: 12,
    ﬣ: 11,
    ﬤ: 9,
    ﬥ: 9,
    ﬦ: 11,
    ﬧ: 11,
    ﬨ: 12,
    שׁ: 11,
    שׂ: 11,
    שּׁ: 11,
    שּׂ: 11,
    אַ: 9,
    אָ: 9,
    אּ: 9,
    בּ: 8,
    גּ: 7,
    דּ: 7,
    הּ: 9,
    וּ: 4,
    זּ: 7,
    טּ: 9,
    יּ: 4,
    ךּ: 8,
    כּ: 6,
    לּ: 6,
    נּ: 4,
    סּ: 8,
    ףּ: 8,
    פּ: 8,
    צּ: 9,
    קּ: 8,
    רּ: 8,
    שּ: 11,
    וֹ: 2,
    בֿ: 8,
    כֿ: 6,
    פֿ: 8,
    ﭐ: 4,
    ﭑ: 4,
    ﭒ: 12,
    ﭓ: 12,
    ﭔ: 5,
    ﭕ: 5,
    ﭖ: 12,
    ﭗ: 12,
    ﭘ: 5,
    ﭙ: 5,
    ﭚ: 12,
    ﭛ: 12,
    ﭜ: 5,
    ﭝ: 5,
    ﭞ: 12,
    ﭟ: 12,
    ﭠ: 5,
    ﭡ: 5,
    ﭢ: 12,
    ﭣ: 12,
    ﭤ: 5,
    ﭥ: 5,
    ﭦ: 12,
    ﭧ: 12,
    ﭨ: 5,
    ﭩ: 5,
    ﭪ: 14,
    ﭫ: 14,
    ﭬ: 6,
    ﭭ: 6,
    ﭮ: 14,
    ﭯ: 14,
    ﭰ: 6,
    ﭱ: 6,
    ﭲ: 9,
    ﭳ: 9,
    ﭴ: 11,
    ﭵ: 11,
    ﭶ: 9,
    ﭷ: 9,
    ﭸ: 11,
    ﭹ: 11,
    ﭺ: 9,
    ﭻ: 9,
    ﭼ: 11,
    ﭽ: 11,
    ﭾ: 9,
    ﭿ: 9,
    ﮀ: 11,
    ﮁ: 11,
    ﮂ: 6,
    ﮃ: 6,
    ﮄ: 6,
    ﮅ: 6,
    ﮆ: 6,
    ﮇ: 6,
    ﮈ: 6,
    ﮉ: 6,
    ﮊ: 8,
    ﮋ: 8,
    ﮌ: 8,
    ﮍ: 8,
    ﮎ: 15,
    ﮏ: 17,
    ﮐ: 8,
    ﮒ: 15,
    ﮓ: 17,
    ﮔ: 8,
    ﮖ: 15,
    ﮗ: 17,
    ﮘ: 8,
    ﮚ: 15,
    ﮛ: 17,
    ﮜ: 8,
    ﮞ: 8,
    ﮟ: 8,
    ﮠ: 8,
    ﮡ: 8,
    ﮢ: 5,
    ﮣ: 5,
    ﮤ: 5,
    ﮥ: 7,
    ﮦ: 5,
    ﮧ: 7,
    ﮨ: 5,
    ﮩ: 7,
    ﮪ: 8,
    ﮫ: 7,
    ﮬ: 8,
    ﮭ: 8,
    ﮮ: 15,
    ﮯ: 15,
    ﮰ: 15,
    ﮱ: 15,
    ﯓ: 11,
    ﯔ: 11,
    ﯕ: 8,
    ﯖ: 8,
    ﯗ: 8,
    ﯘ: 8,
    ﯙ: 8,
    ﯚ: 8,
    ﯛ: 8,
    ﯜ: 8,
    ﯝ: 9,
    ﯞ: 8,
    ﯟ: 8,
    ﯠ: 8,
    ﯡ: 8,
    ﯢ: 8,
    ﯣ: 8,
    ﯥ: 11,
    ﯦ: 5,
    ﯧ: 5,
    ﯨ: 5,
    ﯩ: 5,
    ﯽ: 11,
    ﯾ: 5,
    ﯿ: 5,
    ﱞ: 8,
    ﱟ: 7,
    ﱠ: 7,
    ﱡ: 7,
    ﱢ: 7,
    '﴾': 4,
    '﴿': 4,
    ﷲ: 13,
    '﷼': 22,
    '︠': 7,
    '︡': 7,
    '︢': 7,
    '︣': 7,
    ﺀ: 5,
    ﺁ: 4,
    ﺂ: 4,
    ﺃ: 3,
    ﺄ: 4,
    ﺅ: 8,
    ﺆ: 8,
    ﺇ: 3,
    ﺈ: 4,
    ﺊ: 11,
    ﺋ: 5,
    ﺌ: 5,
    ﺍ: 2,
    ﺎ: 4,
    ﺏ: 12,
    ﺐ: 12,
    ﺑ: 5,
    ﺒ: 5,
    ﺓ: 4,
    ﺔ: 7,
    ﺕ: 12,
    ﺖ: 12,
    ﺗ: 5,
    ﺘ: 5,
    ﺙ: 12,
    ﺚ: 12,
    ﺛ: 5,
    ﺜ: 5,
    ﺝ: 9,
    ﺞ: 9,
    ﺟ: 11,
    ﺠ: 11,
    ﺡ: 9,
    ﺢ: 9,
    ﺣ: 11,
    ﺤ: 11,
    ﺥ: 9,
    ﺦ: 9,
    ﺧ: 11,
    ﺨ: 11,
    ﺩ: 6,
    ﺪ: 6,
    ﺫ: 6,
    ﺬ: 6,
    ﺭ: 8,
    ﺮ: 8,
    ﺯ: 8,
    ﺰ: 8,
    ﺱ: 14,
    ﺲ: 14,
    ﺳ: 11,
    ﺴ: 11,
    ﺵ: 14,
    ﺶ: 14,
    ﺷ: 11,
    ﺸ: 11,
    ﺹ: 19,
    ﺺ: 19,
    ﺻ: 16,
    ﺼ: 16,
    ﺽ: 19,
    ﺾ: 19,
    ﺿ: 16,
    ﻀ: 16,
    ﻁ: 11,
    ﻂ: 11,
    ﻃ: 11,
    ﻄ: 11,
    ﻅ: 11,
    ﻆ: 11,
    ﻇ: 11,
    ﻈ: 11,
    ﻊ: 9,
    ﻋ: 9,
    ﻌ: 8,
    ﻎ: 9,
    ﻏ: 9,
    ﻐ: 8,
    ﻑ: 14,
    ﻒ: 14,
    ﻓ: 6,
    ﻔ: 6,
    ﻕ: 9,
    ﻖ: 9,
    ﻗ: 6,
    ﻘ: 6,
    ﻙ: 11,
    ﻚ: 11,
    ﻛ: 8,
    ﻜ: 8,
    ﻝ: 8,
    ﻞ: 8,
    ﻟ: 5,
    ﻠ: 5,
    ﻡ: 6,
    ﻢ: 6,
    ﻣ: 8,
    ﻤ: 8,
    ﻥ: 8,
    ﻦ: 8,
    ﻧ: 5,
    ﻨ: 5,
    ﻩ: 5,
    ﻪ: 7,
    ﻫ: 8,
    ﻬ: 8,
    ﻭ: 8,
    ﻮ: 8,
    ﻰ: 11,
    ﻲ: 11,
    ﻳ: 5,
    ﻴ: 5,
    ﻵ: 8,
    ﻷ: 9,
    ﻸ: 11,
    ﻹ: 8,
    ﻻ: 8,
    '￼': 18
};
/* tslint:enable */

export const getBannerPreviewTitleLength = (str: string): number => {
    const strLength = str.length;

    const resultLength = str.split('').reduce((length, char) => {
        return length + (charsList[char] || 10);
    }, 0);

    // Движок добавляет +1 за каждый символ кроме последнего
    return resultLength + (strLength ? strLength - 1 : strLength);
};
